import Reports from './ReportsController';

export default Reports;
